import React, { useEffect, useState } from "react";
import { ErrorOutline } from "@mui/icons-material";
import Loading from "../Loading";

export default function Callback() {
  const [element, setElement] = useState(<Loading />);

  const API_URL = "/api/callback";

  useEffect(() => {
    const acquireToken = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const state = params.get("state");
        if (!code) throw Error("Missing auth code");

        const query = state
          ? `code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`
          : `code=${encodeURIComponent(code)}`;

        const res = await fetch(`${API_URL}?${query}`, {
          credentials: "include",
        });

        if (res.status === 200) {
          let redirect = "/home/";
          try {
            const data = await res.json();
            if (typeof data?.redirect === "string" && data.redirect) redirect = data.redirect;
          } catch {
            // fall through to the default "/home/"
          }
          window.location.replace(redirect);
          return;
        }

        throw Error("Sign in failed");
      } catch (err) {
        setElement(
          <div className="failed-sign-in">
            <svg width="156" height="156" viewBox="0 0 24 24">
              <defs>
                <linearGradient id="failed" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#c026d3" />
                  <stop offset="50%" stopColor="#db2777" />
                  <stop offset="100%" stopColor="#ef4444" />
                </linearGradient>
              </defs>
              <ErrorOutline sx={{ fill: "url(#failed)" }} />
            </svg>
            <div className="failed-sign-in-content">
              <h1>Something went wrong.</h1>
              <p>Your sign in attempt failed. Please try again.</p>
            </div>
          </div>,
        );
      }
    };

    acquireToken();
  }, []);

  return element;
}
